module.exports = __webpack_public_path__ + "sounds/d1c938deb7798e89a2b98f3d176f1fef.mp3";


//////////////////
// WEBPACK FOOTER
// ./components/levels/levelPrologue/assets/sounds/hit.mp3
// module id = 86
// module chunks = 0